import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Heart, Truck, Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { imgUrl } from "@/utils/format";

export default function About() {
  const { t } = useTranslation();
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-2">{t("about.kicker")}</div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold mb-4">{t("about.title")}</h1>
      <p className="text-lg text-mute max-w-3xl mb-10">
        {t("about.intro")}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        <Feature icon={<Sparkles />} title={t("about.f1Title")} desc={t("about.f1Desc")} />
        <Feature icon={<Truck />} title={t("about.f2Title")} desc={t("about.f2Desc")} />
        <Feature icon={<Heart />} title={t("about.f3Title")} desc={t("about.f3Desc")} />
      </div>

      <div className="bg-elevated rounded-3xl p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl font-semibold mb-3 flex items-center gap-2"><Store className="w-6 h-6 text-brand-red" /> {t("about.ownerTitle")}</h2>
          <p className="text-mute mb-4">{t("about.ownerText")}</p>
          <Link to="/register?role=restaurant" data-testid="about-owner-cta" className="inline-flex items-center gap-2 bg-brand-red hover:bg-[#C81F2D] text-white px-5 py-3 rounded-full font-semibold">{t("about.ownerCta")}</Link>
        </div>
        <img src={imgUrl("/api/static/images/rest_cover_le_go_t_de_conakry.png")} alt="" className="rounded-2xl aspect-video object-cover" />
      </div>
    </div>
  );
}

function Feature({ icon, title, desc }) {
  return (
    <div className="bg-white border border-sand rounded-2xl p-6">
      <div className="w-10 h-10 rounded-full bg-[#FFF5F6] text-brand-red grid place-items-center mb-3">{icon}</div>
      <h3 className="font-display text-xl font-semibold mb-1">{title}</h3>
      <p className="text-sm text-mute">{desc}</p>
    </div>
  );
}
